import * as React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faShareAlt, faVideo, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from "react-intl";

import './tags.scss';
library.add(faShareAlt, faClock, faVideo);

class Tags extends React.Component {
    render() {
        var tagArray = [];
        var tags = [];
        var readTime = "";
        var timeIcon = this.props.videoId !== "" ? "video" : "clock"; 

        if(this.props.readTime) {
            if(this.props.readTime !== "") {
                readTime = <div className="art-time" ><FontAwesomeIcon icon={timeIcon} /> {this.props.readTime}</div> 
            }
        }

        // split tags string and trim whitespace from values
        if(this.props.tags) {
            tagArray = this.props.tags.split(",").map(function(item) {
                return item.trim();
            });

            if (tagArray) {
                tags = tagArray.map((item, key) =>
                    <div className={"tag " + item.toLowerCase().replace(/\s/g,'')} key={item+key}>
                        <FormattedMessage id={"Tag."+item.toLowerCase().replace(/\s/g,'')} defaultMessage={item} />
                    </div>
                );
            }
        }   

        return ( 
            <div className="tags-time">
                {tags}
                {readTime}
            </div>
        )
    }
}

export default Tags;
